"use client";

import { type Dispatch, type SetStateAction, createContext, useContext } from "react";

export type VariantTypes = "sheet_material" | "tosize_furniture" | null;

type PageVariantContextValue = {
	variant: VariantTypes;
	setVariant: Dispatch<SetStateAction<VariantTypes>>;
};

export const PageVariantContext = createContext({} as PageVariantContextValue);

export const usePageVariantContext = () => {
	const context = useContext(PageVariantContext);

	if (!context) {
		throw new Error("PageVariantContext must be used within a PageVariantContextProvider");
	}

	return context;
};
